const en = {
  navbar: {
    solutions: "Solutions",
    personal_area: "Personal Area",
    training: "Services",
    consulenza: "Consulting",
    open_lab: "Open Source",
    code: "About Me",
    contact: "Contacts",
    login: "Login",
    logout: "Logout",
    register: "Register",
    geoutilities: "Geo Utilities",
    ves: "V.E.S.",
    geodatabase:"Geodata",
    work:"Works"
  },

  footer: {
    f1: "Dr. Geol. Umberto Grechi - Pianoro 40065 (BO)",
  },

  pages: {


    home: {
      t2:"Digital Solutions & Geology and Territory",
      ta:"Featured",
      tb:"Digital Solutions",
      a1: "Geognostic and Geophysical Test Database",
      a2: "V.E.S. Virtual Earth Suite",
      a3:"V.E.S. Test for free",
      a4:"Integrated Geospatial Digital Systems",
      a5:"Custom Development",
      a6:"V.E.S.",
      a7:"Data Processing Services",
      a8:"ORIGAMI – Create, publish, and share your WebGIS",
      dsch:`Operational digital platforms, specialized software and data processing services for professionals and companies in the geological and environmental sector.
            From field data collection to complex analyses, we transform territorial information into practical tools for fast and reliable decision-making.`,
      s1:`Development of operational WebGIS platforms implementing management, calculation and analysis functionalities.`,
      s2:`Custom software and application development.`,
      s3:`Suite for processing and archiving geognostic and geophysical tests.`,
      s4:`Processing services for geognostic, geotechnical and geophysical tests.`,
      dsch2:`Specialized geological consulting supporting designers,
        companies and private clients in land and subsurface evaluation and management`,
      dsch3: "Execution and processing of penetrometric tests",
      dsch4: "Execution and processing of seismic investigations",
      dsch5: "Geological reports",
      dsch6: "Seismic modeling reports",
      dsch7: "digital cartography",
      dsch8: "Topographic surveys",
      imgdescr: [
        "Penetrometric test",
        "Liquefaction phenomenon assessment",
        ],
    },

    geoutpg: {
      imgdescr: [
      "Processing penetrometric tests with CPT Office - Charts",
      "Processing penetrometric tests with CPT Office - SBT",
      "Visualization of penetrometric tests stored in Database",
      "Editing stratigraphic sections between penetrometric tests",
      "Stratigraphic section from penetrometric tests",
      "Archiving and visualization of seismic tests"
        ],
      t1: "Geo Utilities",
      t2: "QGIS Plugin for:",
      t3: "Gallery",
      t4: "Get Free Plugin",
      dsc1: "Processing and archiving static penetrometric tests CPT, CPTE and CPTU;",
      dsc2: "Liquefaction potential index verification;",
      dsc3: "Post-seismic settlement evaluation;",
      dsc4: "Processing and archiving dilatometric tests DMT and SDMT;",
      dsc5: "Creation of borehole sections;",
      dsc6: "Creation of stratigraphic sections between penetrometric tests and/or boreholes;",
      dsc7: "Archiving seismic tests such as HVSR, MASW and DH;",
      dsc8: "Visualization of stored data values and charts.",
    },

    vests: {
      imgdescr2: [
        "Mobile App - collect field data",
        "Online App - View, manage and download data",
        "Desktop Plugin - Process and Archive",
      ],

      t5: "V.E.S.",
      t6: "Virtual Earth Suite",

      t7: "Managed and archived data:",
      t8: "Penetrometric tests",
      t9: "Dilatometric tests",
      t10: "Boreholes",
      t11: "Stratigraphic sections",
      t12: "HVSR, MASW and Down Hole tests",

      t13: "Calculations:",

      t14: "Liquefaction assessment",
      t15: "Free-field post-seismic settlements",

      t18: "Request information",

      dsc10: `V.E.S. (Virtual Earth Suite) is an integrated software platform designed for professionals in the geological and geotechnical field.`,

      dsc11: `The suite supports the entire workflow: from field data acquisition to office-based processing and modelling, centralizing all information within a single digital environment.`,

      dsc12: `During acquisition phases, V.E.S. enables automatic geolocation and storage of investigation points, ensuring traceability and structured data management.`,

      dsc13: `During the analysis phase, the platform performs advanced computations and generates ready-to-use engineering results.`
    },

    digsev:{
        ds1:"Integrated digital geospatial systems",
        ds2:`We develop WebGIS platforms, SaaS solutions, and custom applications that enable the structured and efficient acquisition, management, analysis, and sharing of geospatial data from field data collection to advanced modeling and visualization.
            We integrate digital cartography, spatial databases, and analytical tools to support professionals, engineering firms, and companies in land and subsurface management.`,
        ds3:"what do we develop",
        ds4:"Operational WebGIS for management and visualization of geospatial data",
        ds5:"SaaS platforms for storing and sharing technical data",
        ds6:"Structured geological and geotechnical databases",
        ds7:"Systems for managing geognostic and geophysical tests",
        ds8:"Digital tools for topographic workflows",
        ds9:"Environmental dashboards and monitoring systems",
        ds10:"API integration and mapping services (WMS, WFS)",
    },

    elab_sev:{
      els1: "Servizio Elaborazioni Prove e Modellazione",
      els2:`Offro servizi specialistici di elaborazione, interpretazione e modellazione dei dati provenienti da
       indagini geognostiche e geofisiche, supportando studi professionali, società di ingegneria,
       imprese e pubbliche amministrazioni in tutte le fasi di analisi e gestione delle informazioni.`,
      els3:"Elaborazione prove geognostiche",
      els4:"Sondaggi",
      els5:"Prove penetrometriche (CPT, CPTE, CPTU, SCPTU)",
      els6:"Prove dilatometriche (DMT, SDMT)",

      els7:"Elaborazione prove geofisiche",
      els8:"Indagini HVSR e MASW",
      els9:"Tomografie elettriche (ERT)",
      els10:"Down Hole e sismica a rifrazione",

      els11:"Modellazione",
      els12:"Analisi di risposta sismica locale",
      els13:"Ricostruzioni stratigrafiche",
      els14:"Supporto alla progettazione preliminare ed esecutiva",

      els15:"Analisi geospaziali e servizi GIS",
      els16:"Produzioni di cartografia tematica",
      els17:"Analisi a supporto della pianificazione territoriale",
      els18:"Analisi geomorfologiche a supporto di studi geologici e idrologici",
    },

    login: {
      tl: "Login",
      l1:"User",
      l2:"Password",
      l3:"Sign in",
      l4:"Forgot password?",
      l5:"Don't have an account yet?",
      l6:"Purchase a plan",
      l7:"Reset Password",
      l8:"contact us",
    },

    register: {
      rl: "Request V.E.S.",
      r5:"Send request",
      r2:"Password recovered?",
      r3:"Back to login",
      r6: "I accept the terms and privacy policy",
      r7: "View details"
    },

    toast:{
    ts1:"Sending request...",
    ts2:"Your request has been received.",
    ts3:"An error occurred while sending the request. Please try again later.",
    ts4:'Incorrect user or password!',
    },

    layer: {
      Tgla1: "GeoData",
      Tpla1: "Layers",
      Pla1: "Geognostic Tests",
      Tla1: "CPT",
      Tla2: "CPTU",
      Tla3: "CPTE",
      Tla4: "DMT",
      Tla5: "SDMT",
      Tla6: "DIN",
      Pla2: "Geophysical Tests",
      Tla7: "HVSR",
      Tla8: "MASW",
      Tla9: "REMI",
      Tla10: "DH",
      Tla11: "CH",
      Tla12: "SEISMIC ARRAY",
      Pla3: "Boreholes - Wells",
      Tla13: "WELL",
      Tla14: "BOREHOLE",
      Tla15: "HYDROCARBON BOREHOLE",
      Tla16: "OFFSHORE BOREHOLE",
      ld1: "Manuals & Legends",
      ld2: "Attributions & Licenses",
    },

    whoim:{
        w1:"Umberto Grechi",
        w2:"Geologist • GIS Specialist • Software Developer",
        w3:"About Me",
        w4:`I began my professional path as a Surveyor,
                                working on topographic surveys and developing a strong
                                practical understanding of territory and technical data.`,
        w5:`Later I obtained both bachelor's and master's degrees
                                in Geology, specializing in cartography and GIS systems.
                                Working with geospatial data led me to develop software tools
                                to automate analyses and processes.`,
        w6:`Today I design and develop digital applications created for
                                technical professionals, integrating scientific expertise,
                                GIS and software development.`,
        w7:"Skills",
        w8:"GIS & Geospatial",
        w9:"QGIS & Digital Cartography",
        w10:"WebGIS",
        w11:"Spatial data management",
        w12:"Geospatial analysis",
        w13:"Software Development",
        w14:"React",
        w15:"JavaScript",
        w16:"AJAX",
        w17:"Web Applications",
        w18:"API Integration",
        w19:"Python",
        w20:"Django",
        w21:"PostgreSQL",
        w22:"Geology & Topography",
        w23:"Geological report preparation",
        w24:"Seismic modeling",
        w25:"Execution and processing of geognostic and geophysical tests",
        w26:"Topographic surveys",
        w27:"The sofHare Project",
        w28:`sofHare was born from the real need of technical professionals
                                to have flexible, simple digital tools adaptable
                                to their workflows.`,
        w29:"Structured geospatial data archiving",
        w30:"Custom tools for technical workflows",
        w31:"Ease of use and integration",
        w32:"Work portfolio",
    },

    portfolio:{
        ptf1:"V.E.S. piattaforma integrata per elaborazione, archiviazione e gestione prove geognostiche.",
        ptf2:"Gestione discariche, dal moonitoraggio allo stato avanzamento lavori.",
        ptf3:"Database prove geognostiche - archivi regionali",

        imgdescrptf1: [
          "Test Database",
          "Test Database - data visualization",
          "Geotechnical test processing tools",
          "Borehole processing tools",
          "Android app for field data acquisition and real-time desktop data management",
        ],

        imgdescrptf2: [
          "WebGIS",
          "Editing tools",
          "Analysis and export tools",
        ],

        imgdescrptf3: [
          "WebGIS - regional geotechnical investigations",
          "Data consultation",
        ],

    },

  }
};

export default en;